import { BaseResourceModel } from '../../shared/models/base-resource.model';
import { Client } from '../clients/client.model';
import { Account } from '../accounts/account.model';
import { User } from '../users/user.model';

interface Metadata {
    url?: string;
    background?: string;
}

interface PrivateMetadata {
    max_uses?: number;
    authentication?: string;
    code?: string;
    password?: string;
}

export class PublicLink extends BaseResourceModel {

    constructor(
        public id?: number,
        public uuid?: string,
        public client_id?: number,
        public name?: string,
        public type?: string,
        public metadata?: Metadata,
        public private_metadata?: PrivateMetadata,
        public start_screen?: string,
        public end_screen?: string,
        public expires_at?: string,
        public active?: boolean,
        //
        public qrcode?: string,
        public message?: string,
        public action?: string,
        public error?: boolean,
        //
        public account?: Account,
        public user?: User,
        public client?: Client,
    ) {
        super();
    }

    static fromJson(jsonData: any): PublicLink {

        if (jsonData.metadata) {
            if (typeof jsonData.metadata === 'string') {
                try {
                    jsonData.metadata = JSON.parse(jsonData.metadata);
                } catch (e) {
                    jsonData.metadata = {};
                }
            } else if (typeof jsonData.metadata !== 'object') {
                jsonData.metadata = {};
            }
        }

        if (jsonData.private_metadata) {
            if (typeof jsonData.private_metadata === 'string') {
                try {
                    jsonData.private_metadata = JSON.parse(jsonData.private_metadata);
                } catch (e) {
                    jsonData.private_metadata = {};
                }
            } else if (typeof jsonData.private_metadata !== 'object') {
                jsonData.private_metadata = {};
            }
        }

        return Object.assign(new PublicLink(), jsonData);
    }
}
